import { useSelector } from 'react-redux';
import GitSettings from '../GitSettings';
import { StyledGitTeamSettings } from './GitTeamSettings.style';
import Header from './Header';
import useGitTeamSettings from './useGitTeamSettings';
import useTeamModeHandler from './useTeamModeHandler';
import { selectedTeamSelector } from 'state/selectors/ui-state';

const GitTeamSettings = ({ apiTokens, setApiTokens }) => {
  const selectedTeam = useSelector(selectedTeamSelector);
  const gitTeamSettings = useGitTeamSettings({ teamId: selectedTeam.id });
  const teamModeHandler = useTeamModeHandler({ gitTeamSettings });

  return (
    <StyledGitTeamSettings>
      <Header
        team={selectedTeam}
        selectedReposIds={teamModeHandler.selectedReposIds}
        selectedServicesIds={teamModeHandler.selectedServicesIds}
        isSelectedOnly={teamModeHandler.isSelectedOnly}
        setIsSelectedOnly={teamModeHandler.setIsSelectedOnly}
        isSaveDisabled={teamModeHandler.isSaveDisabled}
        onSave={teamModeHandler.onSave}
      />

      <GitSettings
        apiTokens={apiTokens}
        setApiTokens={setApiTokens}
        modeHandler={teamModeHandler}
      />
    </StyledGitTeamSettings>
  );
};

export default GitTeamSettings;
